// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"ddd43603","667":"0df834be"}[chunkId] + ".chunk.js";
};